import React from "react";
import { H2 } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { AuditLogs } from "../elements/AuditLogs";

export const HistoryAuditLogs = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Audit Log Page" });
  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <H2>{t("Audit log Headline")}</H2>
      </div>
      <AuditLogs />
    </div>
  );
};
